export enum AuthType {
    Linkedin = 'linkedin',
    Insta = 'instagram',
  }

export enum AuthRoutes {
    Linkedin = '/linkedin-ouath',
    Insta = '/insta-oauth',
}